(function () {
  const HOME_TEXT_SELECTOR = [
    '#MainContent .shopify-section .text-block',
    '#MainContent .shopify-section :is(h1, h2, h3, h4, h5, h6, p)',
    '#MainContent .shopify-section :is(.button, .button-secondary, .link)',
    '#MainContent .ts-slider :is(.ts-eyebrow, .ts-heading, .ts-quote, .ts-author)'
  ].join(',');

  const REVEAL_EXCLUDE_SELECTOR = [
    '.scroll-reveal',
    '.visually-hidden',
    '.luxury-quote-section',
    'script',
    'style',
    'noscript',
    'svg',
    'header',
    'footer',
    '#header-group',
    '.header',
    '.footer'
  ].join(',');

  function prepareHomepageTextReveal(root = document) {
    if (!document.body.classList.contains('template-index')) return;

    const scope =
      root.id === 'MainContent'
        ? root
        : root.querySelector?.('#MainContent') || document.querySelector('#MainContent');

    if (!scope) return;

    scope.querySelectorAll(HOME_TEXT_SELECTOR).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (element.matches(REVEAL_EXCLUDE_SELECTOR)) return;
      if (element.closest(REVEAL_EXCLUDE_SELECTOR)) return;
      if (element.closest('.text-block') && !element.classList.contains('text-block')) return;

      element.classList.add('scroll-reveal');

      if (element.matches(':is(.button, .button-secondary, .link)')) {
        element.classList.add('scroll-reveal--delay');
      }
    });
  }

  function initScrollReveal(root = document) {
    prepareHomepageTextReveal(root);

    const revealItems = root.querySelectorAll
      ? root.querySelectorAll('.scroll-reveal:not(.is-visible)')
      : document.querySelectorAll('.scroll-reveal:not(.is-visible)');

    if (!revealItems.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    revealItems.forEach((item) => observer.observe(item));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  document.addEventListener('shopify:section:load', (event) => initScrollReveal(event.target));
})();
